import React, {Fragment, useEffect, useReducer} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import $ from "jquery";

import WithOverlay from "../../popups/withOverlayHoc";
import ShopFeaturePage from "./shopFeaturePage.js/shopFeaturePage";
import ShopCategoryPage from "./shopCategory/shopCategoryPage";
import {ROUTES} from "../../../routes";
import {setShopPageLoaded, setShopPageOpened} from "../../../actions/shopFunctions";
import MaterialSpinner from "../../ui/materialSpinner";
import ShopContext, {
  initialShopContextValues,
  shopContextAction,
  shopContextReducer
} from "./shopCategory/shopNavItemsContext";
import LookCartButton from "../lookNavigation/lookCartButton";
import {setLookOpened, setLookPageOpened} from "../../../actions/lookFunctions";
import {usePrevious} from "../../../misc/helperHooks";
import ShopPingPilotButton from "./shopPingPilotButton";
import {getCommonVisualizerType, IS_PRODUCT_JOURNEY} from "../../../config";
import {setWizardActiveItem} from "../../../actions/wizardFunctions";
import {getQtCategories, loadFiltersOnly} from "../../../api/server-api";
import {getCurrentLayout} from "../../appLayout";
import {setQtCategoriesRequested} from "../../../actions/actionFunctions";
import {setAllowMainLoading} from "../../../actions/serverFunctions";
import {removeLoadingElements} from "../../../loadingLogic";
import {getFeatureGroupFromUrl} from "./shopPagesFunctions";


const ShopPage = (props) => {

  const {shopPageOpened, location, setShopPageOpened, visualizersLoadedLength, lookPageOpened, lookOpened,
    setLookPageOpened, setLookOpened, setWizardActiveItem, allowMainLoading, shopPageLoaded, setShopPageLoaded,
    setQtCategoriesRequested, setAllowMainLoading} = props;

  const [shopContextState, shopContextDispatch] = useReducer(shopContextReducer, initialShopContextValues);
  const {shopActiveCategory, shopActiveFeature} = shopContextState;
  const isShopPage = location.pathname.includes(ROUTES.shop);
  const wasShopPage = usePrevious(isShopPage);
  const cartOpened = lookPageOpened === ROUTES.cart;

  const loadShopPage = async () => {
    if (isShopPage) {
      if (!visualizersLoadedLength && !allowMainLoading && !shopPageLoaded) {
        await loadFiltersOnly();
        setShopPageLoaded(true);
        const layout = getCurrentLayout();
        Object.values(layout.parts).forEach(part => {
          part.createRelatedItems();
        });
        setQtCategoriesRequested(layout.visualizerType);
        getQtCategories(layout.getCurrentLayoutAbbreviation()).then(qtCatResponse => {
          if (qtCatResponse) {
            layout.setQtCategoriesSubparts(qtCatResponse);
          }
        });
      }
      if (!shopPageOpened) {
        setShopPageOpened(true);
      } else if (shopPageOpened) {
        const overlay = document.querySelector(".overlay--shop");
        if (overlay && (!overlay.style.display || overlay.style.display === "none")) {
          $(overlay).fadeIn(300)
        }
      }
      const splitted = location.pathname.split(ROUTES.shop + "/");
      if (!splitted[1]) {
        splitted[1] = getCommonVisualizerType() === "bathroom" ? "vanity_faucet" : "faucet"; // set faucet by the default
      }
      if (splitted[1]) {
        const splittedAfterShop = splitted[1].split("/");
        const categoryId = splittedAfterShop[0];
        const skuId = splittedAfterShop[1];
        if (categoryId && (categoryId !== shopActiveCategory)) {
          const featureGroup = getFeatureGroupFromUrl(categoryId);
          shopContextDispatch(shopContextAction({
            shopActiveCategory: categoryId,
            shopFeatureGroup: featureGroup  // even if it is not found, set null
          }));
        }
        if (skuId && (skuId !== shopActiveFeature)) {
          shopContextDispatch(shopContextAction({shopActiveFeature: skuId}))
        } else if (shopActiveFeature && !skuId) {
          shopContextDispatch(shopContextAction({shopActiveFeature: ""}))
        }
      }
      removeLoadingElements("Shop");
      // const category = ""
    } else if (wasShopPage) {
      // other component will unmount logic
      if (shopPageOpened && !cartOpened) {
        setShopPageOpened(false);
      }
      if (!allowMainLoading) {
        setAllowMainLoading(true); // here we request all data to show View in Visualizer without the loading
      }
    }
  }

  useEffect(() => {
    loadShopPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  if (!shopPageOpened) {
    return null
  }

  const overlayClick = (event) => {
    if (cartOpened && !event.target.closest(".look-cart-button--shop")) {
      setLookPageOpened("");
    }
    if (lookOpened) {
      setLookOpened(null);
      setLookPageOpened("");
      setWizardActiveItem(null);
    }
  }

  return (
    <ShopContext.Provider value={{shopContextState, shopContextDispatch}} >
      <WithOverlay className={"overlay--white2 overlay--shop" + (cartOpened || lookOpened ? " overlay--blurred" : "")}>
        {() => {
          if (!shopPageLoaded) {
            return (
              <MaterialSpinner withCounter={true}/>
            )
          }
          return (
            <Fragment>
              <div className="shop-wrapper" onClick={overlayClick}>
                {shopActiveCategory && !shopActiveFeature ? <ShopCategoryPage /> : null}
                {shopActiveFeature ? <ShopFeaturePage/> : null}
                {IS_PRODUCT_JOURNEY ? null : <LookCartButton className="look-cart-button--shop"/>}
                <ShopPingPilotButton/>
              </div>
            </Fragment>
          )
        }}
      </WithOverlay>
    </ShopContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {shopPageOpened, shopActiveCategory, shopActiveFeature, shopPageLoaded} = store.shopState;
  const {visualizersLoaded, allowMainLoading} = store.serverState;
  const {lookPageOpened, lookOpened} = store.lookState;

  return {
    shopPageOpened,
    shopActiveCategory,
    shopActiveFeature,
    fabricatorData: store.fabricatorState,
    visualizersLoadedLength: visualizersLoaded.length,
    lookPageOpened,
    lookOpened,
    allowMainLoading,
    shopPageLoaded,
  };
};

const mapDispatchToProps = {
  setShopPageOpened,
  setLookPageOpened,
  setLookOpened,
  setWizardActiveItem,
  setShopPageLoaded,
  setQtCategoriesRequested,
  setAllowMainLoading,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopPage)
)
